export enum FrequenciesEnum {
    NotSet = 0,
    Semesters = 1,
    Quarter = 2,
    Year = 3,
    Month = 4,
}
